import { type AxiosResponse } from 'axios'
import globalAxios from '@/common/utils/axios'

export async function getZendeskToken(): Promise<AxiosResponse<string>> {
  return globalAxios.get('/xhr/support/zendesk/jwt-authentication')
}
